/**
 * Black November bundle builder — sections/knott-bn-offer.liquid.
 *
 * Buy 2 Get 2 Free: the shopper picks FOUR real bracelets and all four go into
 * the cart as real line items. Shopify's BxGy does NOT add the free ones for
 * you, which is the single most common way a bundle page like this ships
 * broken — it shows "2 free" and then charges for four.
 *
 * WHAT MAKES A PIECE FREE: the discount
 * "Black November · Buy 2, Get 2 Free" frees the TWO CHEAPEST eligible items.
 * freeCount() and the cheapest-first ranking below mirror that exactly. Every
 * KNOTT bracelet is $30 today so it rarely shows, but the moment a dearer
 * piece is in the mix the page must free the cheap ones or the total on screen
 * will not be the total at checkout. Do not "fix" this to free the dearest.
 *
 * FREE DELIVERY is a separate automatic discount
 * ("Black November · Free delivery on 4+ pieces", minimum 4 items, Lebanon),
 * so it follows from the same four line items. It is shown as a promise here;
 * checkout is what actually applies it. Verified at a real checkout:
 * $124.00 -> $60.00 with both Beirut and Outside Beirut showing FREE.
 */
(function () {
  var ROOT = '[data-bn]';

  function money(cents, fmt) {
    var body = (cents / 100).toFixed(2);
    if (cents >= 100000) body = body.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // The shop's money_format is a Liquid string; the symbol either side of
    // {{amount}} is all that is needed here.
    var m = String(fmt || '${{amount}}').split(/\{\{\s*amount[^}]*\}\}/);
    return (m[0] || '') + body + (m[1] || '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function Builder(root) {
    this.root = root;
    var cfg = root.querySelector('[data-bn-config]');
    try { this.config = JSON.parse(cfg.textContent); } catch (e) { this.config = {}; }

    this.products = (this.config.products || []).filter(function (p) {
      return p.variants && p.variants.length;
    });
    if (!this.products.length) return;

    this.fmt = this.config.money_format;
    this.slots = root.querySelector('[data-bn-slots]');
    this.qty = this.readQty();
    this.picks = [];
    this.seed();

    root.addEventListener('change', this.onChange.bind(this));
    root.addEventListener('click', this.onClick.bind(this));
    this.render();
  }

  Builder.prototype.readQty = function () {
    var on = this.root.querySelector('[data-bn-qty]:checked');
    return Number(on && on.value) || 1;
  };

  Builder.prototype.indexOfHandle = function (handle) {
    if (!handle) return -1;
    var needle = '/products/' + handle;
    for (var i = 0; i < this.products.length; i++) {
      if (String(this.products[i].url || '').indexOf(needle) > -1) return i;
    }
    return -1;
  };

  /**
   * Pre-fill the four slots with FOUR DIFFERENT pieces.
   *
   * This used to seed every slot from products[0], so the page opened with
   * four identical cards — same photo, same title, four times over. It read
   * as a rendering fault rather than a choice, and it hid the fact that the
   * pieces are swappable at all.
   *
   * The order comes from the section's "Default picks" setting (handles), so
   * the shop can lead with its best sellers without touching code. Anything
   * missing falls through to the next UNUSED product rather than repeating
   * one already on screen.
   */
  Builder.prototype.seed = function () {
    var wanted = this.config.defaults || [];
    var used = {};

    for (var i = 0; i < 4; i++) {
      if (this.picks[i]) continue;

      var p = this.indexOfHandle(wanted[i]);
      if (p < 0 || used[p]) {
        p = 0;
        while (used[p] && p < this.products.length - 1) p++;
      }

      used[p] = true;
      this.picks[i] = { p: p, v: this.firstVariant(this.products[p]).id };
    }
  };

  Builder.prototype.firstVariant = function (product) {
    return product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
  };

  Builder.prototype.at = function (i) {
    var st = this.picks[i];
    var product = this.products[st.p] || this.products[0];
    var variant = product.variants.filter(function (v) { return v.id === st.v; })[0] ||
      this.firstVariant(product);
    return { product: product, variant: variant };
  };

  // Mirrors "Black November · Buy 2, Get 2 Free": buy 2, get 2, once per order.
  Builder.prototype.freeCount = function (n) {
    return n >= 4 ? 2 : 0;
  };

  Builder.prototype.totals = function () {
    var n = this.qty;
    var lines = [];
    for (var i = 0; i < n; i++) lines.push(this.at(i).variant);

    var was = lines.reduce(function (s, v) { return s + v.price; }, 0);

    // Cheapest first, exactly as the Shopify discount allocates.
    var ranked = lines.map(function (v, i) { return { price: v.price, i: i }; })
      .sort(function (a, b) { return a.price - b.price || b.i - a.i; });
    var free = ranked.slice(0, this.freeCount(n));
    var freeSet = {};
    free.forEach(function (f) { freeSet[f.i] = true; });

    var now = was - free.reduce(function (s, f) { return s + f.price; }, 0);
    return {
      lines: lines, was: was, now: now, freeSet: freeSet,
      ok: lines.every(function (v) { return v.available; })
    };
  };

  Builder.prototype.optionSelects = function (i) {
    var pick = this.at(i);
    var product = pick.product;
    var variant = pick.variant;
    if (!product.options || !product.options.length) return '';

    return product.options.map(function (name, o) {
      var seen = {};
      var values = [];
      product.variants.forEach(function (v) {
        if (!seen[v.options[o]]) { seen[v.options[o]] = 1; values.push(v.options[o]); }
      });
      if (values.length < 2) return '';

      var opts = values.map(function (value) {
        var out = !product.variants.some(function (v) {
          return v.available && v.options[o] === value;
        });
        var shown = String(value).replace(/\s*\((\d+(?:[.,]\d+)?)\s*cm\)/i, ' $1cm');
        return '<option value="' + esc(value) + '"' +
          (value === variant.options[o] ? ' selected' : '') +
          (out ? ' disabled' : '') + '>' +
          esc(out ? shown + ' (sold out)' : shown) + '</option>';
      }).join('');

      return '<select data-bn-opt="' + i + ':' + o + '" aria-label="' +
        esc(name) + ' for bracelet ' + (i + 1) + '">' + opts + '</select>';
    }).join('');
  };

  Builder.prototype.render = function () {
    var n = this.qty;
    var t = this.totals();
    var self = this;
    var html = '';

    for (var i = 0; i < n; i++) {
      var pick = this.at(i);
      var v = pick.variant;
      var img = v.image || pick.product.image || '';
      var isFree = !!t.freeSet[i];

      var products = this.products.map(function (p, pi) {
        return '<option value="' + pi + '"' + (pi === self.picks[i].p ? ' selected' : '') +
          '>' + esc(p.title) + '</option>';
      }).join('');

      html += '<div class="bn-slot' + (isFree ? ' is-free' : '') + '" data-bn-slot="' + i + '">' +
        '<span class="bn-slot__media"><img src="' + esc(img) + '" alt="" width="54" height="54" loading="lazy">' +
        '<b class="bn-slot__n">' + (i + 1) + '</b></span>' +
        '<span class="bn-slot__body">' +
          '<span class="bn-slot__top"><span class="bn-slot__name">' + esc(pick.product.title) + '</span>' +
          '<span class="bn-slot__price">' +
            (isFree
              ? '<s>' + money(v.price, this.fmt) + '</s><b class="bn-free">FREE</b>'
              : '<b>' + money(v.price, this.fmt) + '</b>') +
          '</span></span>' +
          '<span class="bn-slot__picks">' +
            '<select data-bn-product="' + i + '" aria-label="Bracelet ' + (i + 1) + '">' + products + '</select>' +
            this.optionSelects(i) +
          '</span>' +
        '</span>' +
      '</div>';
    }

    this.slots.innerHTML = html;
    this.paint(t);
  };

  Builder.prototype.paint = function (t) {
    t = t || this.totals();
    var n = this.qty;
    var root = this.root;

    root.querySelectorAll('[data-bn-qty]').forEach(function (input) {
      var card = input.closest('.bn-offer');
      if (card) card.classList.toggle('is-on', input.checked);
    });

    // "4 of 4 bracelets selected" — every slot is pre-filled, so this reads as
    // a completeness check rather than a counter that starts empty.
    var prog = root.querySelector('[data-bn-progress]');
    if (prog) {
      prog.hidden = n < 2;
      var count = root.querySelector('[data-bn-count]');
      var need = root.querySelector('[data-bn-need]');
      var fill = root.querySelector('[data-bn-fill]');
      if (count) count.textContent = String(n);
      if (need) need.textContent = String(n);
      if (fill) fill.style.width = '100%';
    }

    var total = root.querySelector('[data-bn-total]');
    if (total) total.textContent = money(t.now, this.fmt);

    var saving = root.querySelector('[data-bn-saving]');
    if (saving) {
      var diff = t.was - t.now;
      saving.hidden = diff <= 0;
      saving.textContent = 'You save ' + money(diff, this.fmt) +
        (n >= 4 ? ' + free delivery' : '');
    }

    var label = root.querySelector('[data-bn-label]');
    var btn = root.querySelector('[data-bn-add]');
    if (btn) btn.disabled = !t.ok;
    if (label) {
      label.textContent = t.ok
        ? (n === 1 ? 'ADD TO CART — ' : 'ADD ' + n + ' TO CART — ') + money(t.now, this.fmt)
        : 'Pick an available option';
    }
  };

  Builder.prototype.onChange = function (event) {
    var el = event.target;
    if (!(el instanceof HTMLElement)) return;

    if (el.matches('[data-bn-qty]')) {
      this.qty = Number(el.value) || 1;
      this.render();
      return;
    }

    if (el.matches('[data-bn-product]')) {
      var i = Number(el.dataset.bnProduct);
      this.picks[i].p = Number(el.value);
      this.picks[i].v = this.firstVariant(this.products[this.picks[i].p]).id;
      this.render();
      return;
    }

    if (el.matches('[data-bn-opt]')) {
      var parts = el.dataset.bnOpt.split(':').map(Number);
      var slot = parts[0];
      var o = parts[1];
      var pick = this.at(slot);
      var want = (pick.variant.options || []).slice();
      want[o] = el.value;

      // Prefer an available variant that matches the most chosen options.
      var best = pick.product.variants.reduce(function (acc, v) {
        if (v.options[o] !== el.value) return acc;
        var score = v.available ? 100 : 0;
        v.options.forEach(function (x, k) { if (k !== o && x === want[k]) score += 1; });
        return score > acc.score ? { score: score, v: v } : acc;
      }, { score: -1, v: null });

      if (best.v) this.picks[slot].v = best.v.id;
      this.render();
    }
  };

  Builder.prototype.onClick = function (event) {
    var btn = event.target instanceof Element && event.target.closest('[data-bn-add]');
    if (btn) this.add(btn);
  };

  Builder.prototype.add = function (btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var self = this;
    var t = this.totals();
    if (!t.ok) return;

    var err = this.root.querySelector('[data-bn-err]');
    var label = this.root.querySelector('[data-bn-label]');
    if (err) err.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';

    // One line item per chosen piece. All four must be in the cart for the
    // BxGy and the 4-item free-shipping rule to fire.
    var items = t.lines.map(function (v) { return { id: v.id, quantity: 1 }; });
    var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add this bundle.');
        }
        window.location.href = routes + 'cart';
      });
    }).catch(function (e) {
      btn.removeAttribute('aria-busy');
      self.paint();
      if (err) {
        err.textContent = e && e.message ? e.message : 'Could not add this bundle.';
        err.hidden = false;
      }
    });
  };

  function start() {
    document.querySelectorAll(ROOT).forEach(function (root) {
      if (root.dataset.bnInit === '1') return;
      root.dataset.bnInit = '1';
      new Builder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();